import { Globe } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const languages = [
  { code: "en" as const, label: "EN" },
  { code: "sl" as const, label: "SI" },
];

const LanguageSelector = () => {
  const { lang, setLang } = useLanguage();

  return (
    <div className="flex items-center gap-0.5 text-sm text-foreground/60">
      <Globe className="w-4 h-4" />
      {languages.map((l, i) => (
        <span key={l.code} className="flex items-center">
          <button
            onClick={() => setLang(l.code)}
            className={`inline-flex items-center justify-center h-6 min-w-6 px-1.5 py-1 rounded hover:text-foreground transition-colors ${lang === l.code ? "text-foreground font-semibold" : ""}`}
            aria-label={`Switch language to ${l.label}`}
          >
            {l.label}
          </button>
          {i < languages.length - 1 && <span aria-hidden="true" className="opacity-50">/</span>}
        </span>
      ))}
    </div>
  );
};

export default LanguageSelector;
